import { useVContextMenuContext } from './hook';
import type { VContextMenuDividerProps } from './type';

export const VContextMenuDivider = (_props: VContextMenuDividerProps) => {
  const { style } = useVContextMenuContext();

  return (
    <div
      aria-label="v-context-menu-divider"
      className={style.divider}
      role="separator"
    />
  );
};

VContextMenuDivider.displayName = 'VContextMenuDivider';
